import { render, staticRenderFns } from "./TransactionCancelled.vue?vue&type=template&id=14e7e70c&scoped=true"
import script from "./TransactionCancelled.vue?vue&type=script&lang=js"
export * from "./TransactionCancelled.vue?vue&type=script&lang=js"
import style0 from "./TransactionCancelled.vue?vue&type=style&index=0&id=14e7e70c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e7e70c",
  null
  
)

export default component.exports